import React from 'react'
import './FaultFirstPageCustom.css';
import { useEffect, useState } from 'react';
import "./Horizantal.css"
import * as $ from 'jquery';
import useHttp from '../../../../hook/use-http';
import { API_URL_MAIN } from '../../../../constants/driveglobalfilterinitalstates';
import { Link, Navigate } from "react-router-dom";
import Table from './Table';
import NoTableData from '../../../../componets/Dashboard/Driveanalysis/NoTableData';
import ChartLoader from '../../Driveanalysis/ChartLoader';
import WaterMark from '../../DashboardMain/WaterMark';

function FaultFirstPageDataBars(props) {
  let { title, template_id, show, soarting, gloablfilter, IND } = props;
  const [tableData, setTableData] = useState([]);
  const [tablehead, settablehead] = useState([]);
  const [tableBarData, setTableBarData] = useState([]);
  const [tableAlarmData, setTableAlarmData] = useState([]);
  const [tableDtcData, setTableDtcData] = useState([]);
  const [faultSelected, setfaultSelected] = useState("Occurrence");
  const [faultPercent, setFaultPercent] = useState([]);
  const [faultPercentAlram, setFaultPercentAlram] = useState([]);
  const [faultPercentDtc, setFaultPercentDtc] = useState([]);

  const { isLoading, error, sendReq: fetchData } = useHttp();
  let post_fix = "";

  if (IND == "RANGE") {
    post_fix = "Km";
  }

  function addECUPercentFault(arr) {
    const max_value = Math.max.apply(Math, arr.map(function (o) { return o.occ.value; }));
    let percentArr = [];
    arr.map((val, i) => {
      var percent = Math.ceil((val.occ.value / max_value) * 100);
      percentArr.push(isNaN(percent) ? 0 : percent);
    })
    return percentArr
  }

  function addECU(dataArr, chngKey) {
    const mainECU = ["BCS", "BMS", "DCDC", "MCU", "OBC", "VCU"];
    mainECU.forEach(element => {
      var index = dataArr.findIndex(x => x.key.ECU == element);
      index === -1 && dataArr.push({
        "key": { "ECU": element }, "doc_count": 0, [`${chngKey}`]: { "value": 0 }
      })
    });
    let dataA = dataArr.sort(function (a, b) {
      return a.key.ECU.localeCompare(b.key.ECU);
    });
    return dataA;
  }

  const singleVinSelected = (vin) => {
    props.singleVinSelected(vin);
  }

  const appyData = (data) => {
    const thead = { "head1": "Vin", "head2": "Occurrence" };
    const res_result = data;
    let responce = [];
    if (res_result.length != 0) {
      let temp_result = res_result;
      temp_result.map(obj => {
        responce.push({ key: obj.key.vehicleId, occ: (obj.occ.value) })

      })
      setTableData((prestate) => responce);
      settablehead(thead)
    } else {
      setTableData((prestate) => []);
      settablehead([])
    }
  }

  const appyBarData = (data) => {
    const thead = { "head1": "Vin", "head2": "Occurrence" };
    const mainECU = [{ "key": "BCS", "occ": 0 }, { "key": "BMS", "occ": 0 }, { "key": "DCDC", "occ": 0 }, { "key": "MCU", "occ": 0 }, { "key": "OBC", "occ": 0 }, { "key": "VCU", "occ": 0 }];
    const res_result = data;
    let responce = [];

    let temp_result = res_result;
    temp_result.map(obj => {
      responce.push({ key: obj.key.ECU, occ: (obj.occ.value) })

    })

    const ecu = addECU(data, "occ")
    setFaultPercentAlram(addECUPercentFault(ecu));
    setTableAlarmData(ecu);
  }

  const appyDtcData = (data) => {
    const thead = { "head1": "Vin", "head2": "Count" };
    const res_result = data;
    let responce = [];
    let temp_result = res_result;
    temp_result.map(obj => {
      responce.push({ key: obj.key.ECU, occ: (obj.occ.value) })
    })

    const ecu = addECU(data, "occ")
    setFaultPercentDtc(addECUPercentFault(ecu));
    setTableDtcData(ecu);
  }

  const appyDataDuration = (data) => {
    const res_result = data;
    const thead = { "head1": "Vin", "head2": "Mins" };

    let responce = [];
    if (res_result.length != 0) {
      let temp_result = res_result;
      temp_result.map(obj => {
        responce.push({ key: obj.key.vehicleId, occ: (obj.occ.value) })
      })
      setTableData((prestate) => responce);
      settablehead(thead)
    } else {
      setTableData((prestate) => []);
    }
  }

  const filterChnaged = (event) => {
    setfaultSelected(event.target.value)
    let value = event.target.value
    if (value == "Duration") {
      fetchData({ url: API_URL_MAIN + "faultfirstpage/Topvehicleswithfaultsduration", body: { filterdata: gloablfilter, IND, soart: event.target.value } }, appyDataDuration)
    } else {
      fetchData({ url: API_URL_MAIN + "faultfirstpage/Topvehicleswithfaults", body: { filterdata: gloablfilter, IND, soart: event.target.value } }, appyData)
    }
  }

  const responceData = (data) => {
    const ecu = addECU(data, "occ")
    setFaultPercent(addECUPercentFault(ecu));
    setTableBarData(ecu)
  }

  function generateBarGraph(wrapper) {

    // Set Up Values Array
    var values = [];

    // Get Values and save to Array
    $(wrapper + ' .bar').each(function (index, el) {
      values.push($(this).data('value'));
    });

    // Get Max Value From Array
    var max_value = Math.max.apply(Math, values);

    // Set width of bar to percent of max value
    $(wrapper + ' .bar').each(function (index, el) {
      var bar = $(this),
        value = bar.data('value'),
        percent = Math.ceil((value / max_value) * 100);

      // Set Width & Add Class
      // bar.width(percent + '%');
      bar.addClass('in');
    });
  }

  useEffect(() => {
    fetchData({ url: API_URL_MAIN + "faultfirstpage/Topvehicleswithfaults", body: { filterdata: gloablfilter, IND } }, appyData)
    fetchData({ url: API_URL_MAIN + 'faultfirstpage/faultanalysis', body: { filterdata: gloablfilter, IND } }, responceData);
    fetchData({ url: API_URL_MAIN + 'faultfirstpage/alarmanalysis', body: { filterdata: gloablfilter, IND } }, appyBarData);
    fetchData({ url: API_URL_MAIN + 'faultfirstpage/dtcanalysis', body: { filterdata: gloablfilter, IND } }, appyDtcData);
  }, [gloablfilter]);  // Fully reference jQuery after this point. 

  useEffect(() => {
    generateBarGraph('#dashboard-stats');
    generateBarGraph('#dashboard-statsUFA')
    generateBarGraph('#dashboard-statsDTC')
  }, [tableBarData, tableAlarmData, tableDtcData]);

  return (
    <div className="row">
      <div className="col-md-3 col-sm-12 pr-0">
        <div className="v-title chartboxPageOne">
          <div className="row">
            <div className="col-md-12 col-sm-6 col-lg-7">
              <div className="titlebg">Vehicle with Fault</div>
            </div>
            <div className="col-md-12 col-sm-6 col-lg-5">
              <select className="form-select form-select-sm" aria-label="Default select example" onChange={filterChnaged} value={faultSelected}>
                <option value="Duration">Duration</option>
                <option value="Occurrence">Occurrence</option>
              </select>
            </div>
          </div>
          <div className="chartHGT">
            <WaterMark />
            <div className="table-responsive ">
              {(isLoading) ? <ChartLoader /> : <Table data={tableData} head={tablehead} singleVinSelected={singleVinSelected} post_fix={post_fix} />}
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-3 col-sm-12 pr-0">
        <div className="v-title chartboxPageOne">
          <div className="titlebg">Fault analysis</div>
          <div className="chartHGT">
            <div className="boxHead">
              <div className="float-start">
                <p className=" boxHeadText">ECU</p>
              </div>
              <div className="float-end">
                <p className="boxHeadText">Vehicle Count</p>
              </div>
            </div>
            <div className="chart-wrap">
              <WaterMark />
              <div id="dashboard-stats" className="chart bars-horizontal brand-primary">
                {(tableBarData.length == 0) ? <NoTableData /> : tableBarData.map((x, i) => {
                  return (<div className="row" key={x.key}>
                    <span className="label">{x.key.ECU}</span>
                    <div className="bar-wrap">
                      <div className="bar" data-value={x.occ.value} style={{ width: faultPercent[i] + "%" }} />
                    </div>
                    <span className="number">{x.occ.value}</span>
                  </div>)
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-md-3 col-sm-12 pr-0">
        <div className="v-title chartboxPageOne">
          <div className="titlebg">Alarm analysis</div>
          <div className="chartHGT">
            <div className="boxHead">
              <div className="float-start">
                <p className=" boxHeadText">ECU</p>
              </div>
              <div className="float-end">
                <p className="boxHeadText">Vehicle Count</p>
              </div>
            </div>
            <div className="chart-wrap">
              <WaterMark />
              <div id="dashboard-statsUFA" className="chart bars-horizontal brand-primary">
                {(tableAlarmData.length == 0) ? <NoTableData /> : tableAlarmData.map((x, i) => {

                  return (<div className="row" key={x.key}>
                    <span className="label">{x.key.ECU}</span>
                    <div className="bar-wrap">
                      <div className="bar" data-value={x.occ.value} style={{ width: faultPercentAlram[i] + "%" }} />
                    </div>
                    <span className="number">{x.occ.value}</span>
                  </div>)
                })}</div></div>
          </div>
        </div>
      </div>
      <div className="col-md-3 col-sm-12 pr-0">
        <div className="v-title chartboxPageOne">
          <div className="titlebg">DTC analysis</div>
          <div className="chartHGT">
            <div className="boxHead">
              <div className="float-start">
                <p className=" boxHeadText">ECU</p>
              </div>
              <div className="float-end">
                <p className="boxHeadText">Vehicle Count</p>
              </div>
            </div>
            <div className="chart-wrap">
              <WaterMark />
              <div id="dashboard-statsDTC" className="chart bars-horizontal brand-primary">
                {(tableDtcData.length == 0) ? <NoTableData /> : tableDtcData.map((x, i) => {
                  return (<div className="row" key={x.key}>
                    <span className="label">{x.key.ECU}</span>
                    <div className="bar-wrap">
                      <div className="bar" data-value={x.occ.value} style={{ width: faultPercentDtc[i] + "%" }} />
                    </div>
                    <span className="number">{x.occ.value}</span>
                  </div>)
                })}</div></div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default FaultFirstPageDataBars;